export default __webpack_public_path__ + "static/media/bag-delivery.858365f3.svg";